import React, {Component} from "react";
import {withRouter,NavLink } from "react-router-dom";
import {connect} from "react-redux";
import {Form, Input, Button, Select, message, Spin, Checkbox} from "antd";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import {Row, Col, Tooltip as Toltip, Popover} from 'antd';

import wasabiDarkLogo from "../../../assets/logo/amove-dark-logo.svg";
import arrowLeft from "../../../assets/img/icon/arrow-left-icon.svg";
import "./editPackage.scss";
import queryString from "query-string";

class editPackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            formValid: true,
            sso: false,
            logs: false,
        };
    }

    componentDidMount() {
        setTimeout(() => {
            const queryParams = queryString.parse(this.props.location.search);
            const queryData = queryParams.data ? JSON.parse(queryParams.data) : {};
            this.props.form.setFieldsValue({
                name: queryData.name,
                description: queryData.description,
                price: queryData.price,
                priceID: queryData.priceId,
                duration: queryData.duration.toString(),
                maxAdminUsers: queryData.maxAdminUsers,
                maxCreativeUsers: queryData.maxCreativeUsers,
                maxStandardUsers: queryData.maxStandardUsers,
                maxStorage: queryData.maxStorage,
                maxConnections: queryData.maxConnections,
                maxProjects: queryData.maxProjects,
                maxTeams: queryData.maxTeams,
                maxDrives: queryData.maxDrives,
                maxSyncs: queryData.maxSyncs,
                sso: queryData.sso,
                logs: queryData.logs,
            });
            console.log(queryData.sso)
            console.log(queryData.logs)
            this.setState({ sso: queryData.sso, logs : queryData.logs });

        }, 0);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        console.log("submit account");
        this.setState({ loading: true });
        const {name, description, price, priceID, duration, maxAdminUsers, maxCreativeUsers, maxStandardUsers, maxStorage, maxConnections, maxProjects, maxTeams, maxDrives, maxSyncs, sso, logs} = this.props.form.getFieldsValue();

        const queryParams = queryString.parse(this.props.location.search);
        const queryData = queryParams.data ? JSON.parse(queryParams.data) : {};

        CloudFlyerAPI.product_packages
            .updatePackage({
                "id": queryData.id,
                "name": name,
                "description": description,
                "price": parseInt(price),
                "priceId": priceID,
                "duration": parseInt(duration),
                "maxAdminUsers": parseInt(maxAdminUsers),
                "maxCreativeUsers": parseInt(maxCreativeUsers),
                "maxStandardUsers": parseInt(maxStandardUsers),
                "maxStorage": parseInt(maxStorage),
                "maxConnections": parseInt(maxConnections),
                "maxProjects": parseInt(maxProjects),
                "maxTeams": parseInt(maxTeams),
                "maxDrives": parseInt(maxDrives),
                "maxSyncs": parseInt(maxSyncs),
                "sso": sso,
                "logs": logs,
                "deleted": queryData.deleted
            })
            .then(() => {
                message.success("Package updated Successfully!");
                this.setState({ loading: false });
                this.props.form.resetFields(); // Reset form after success
                this.props.history.push("/productPackages" );
            })
            .catch((err) => {
                message.error("Something went wrong!");
                this.setState({ loading: false });
            });


    };
    checkIfFormIsFilled = () => {
        const values = this.props.form.getFieldsValue();
        const requiredFields = ["name", "price", "priceID", "duration",
            "maxAdminUsers", "maxCreativeUsers", "maxStandardUsers",
            "maxStorage", "maxConnections", "maxProjects", "maxTeams",
            "maxDrives", "maxSyncs"];

        const allFieldsFilled = requiredFields.every(field => values[field] && values[field] !== "");
        this.setState({ formValid: allFieldsFilled });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {Option} = Select;
        const { loading, formValid } = this.state;
        return (
            <div className="add-new-user-container less-margin">
                <div className="back-wrapper">
                    <NavLink to="/productPackages"><img src={arrowLeft} alt="icon"/> Back</NavLink>
                </div>
                <div className="content-box">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo}/>
                    </div>

                    <div className="add-user-form">
                        <Form
                            layout="horizontal"
                            onSubmit={this.handleSubmit.bind(this)}
                            className="user-form"
                        >
                            <Form.Item>
                                {getFieldDecorator("name")(
                                    <Input placeholder="Name" className="user-input" onChange={this.checkIfFormIsFilled} />
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("description")(
                                    <Input placeholder="Description" className="user-input" onChange={this.checkIfFormIsFilled} />
                                )}
                            </Form.Item>

                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>
                                    <Form.Item>
                                        {getFieldDecorator("price")(
                                            <Input placeholder="Price" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" md={12} span={24}>
                                    <Form.Item>
                                        {getFieldDecorator("priceID")(
                                            <Input placeholder="Price ID" className="user-input" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>
                                    <Form.Item>
                                        {getFieldDecorator("duration")(
                                            <Select placeholder="Duration" onChange={this.checkIfFormIsFilled}>
                                                <Option value="1">Monthly</Option>
                                                <Option value="2">Annual</Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" md={12} span={24}>

                                    <Form.Item>
                                        {getFieldDecorator("maxAdminUsers")(
                                            <Input placeholder="Max Admin Users" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>

                                </Col>
                            </Row>
                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>


                                    <Form.Item>
                                        {getFieldDecorator("maxCreativeUsers")(
                                            <Input placeholder="Max Creative Users" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" md={12} span={24}>

                                    <Form.Item>
                                        {getFieldDecorator("maxStandardUsers")(
                                            <Input placeholder="Max Standard Users" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>

                                </Col>
                            </Row>
                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>

                                    <Form.Item>
                                        {getFieldDecorator("maxStorage")(
                                            <Input placeholder="Max Storage" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col className="gutter-row" md={12} span={24}>

                                    <Form.Item>
                                        {getFieldDecorator("maxConnections")(
                                            <Input placeholder="Max Connections" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>

                                </Col>
                            </Row>
                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>

                                    <Form.Item>
                                        {getFieldDecorator("maxProjects")(
                                            <Input placeholder="Max Projects" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col className="gutter-row" md={12} span={24}>


                                    <Form.Item>
                                        {getFieldDecorator("maxTeams")(
                                            <Input placeholder="Max Teams" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>

                                    <Form.Item>
                                        {getFieldDecorator("maxDrives")(
                                            <Input placeholder="Max Drives" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col className="gutter-row" md={12} span={24}>


                                    <Form.Item>
                                        {getFieldDecorator("maxSyncs")(
                                            <Input placeholder="Max Syncs" className="user-input" type="number" onChange={this.checkIfFormIsFilled} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={30} type="flex">
                                <Col className="gutter-row" md={12} span={24}>
                                    <Form.Item>
                                        {getFieldDecorator("sso")(
                                            <Checkbox onChange={(e)=>{
                                                this.state.sso = e.target.checked;
                                                console.log(this.state.sso)
                                            }} checked={this.state.sso}>SSO</Checkbox>
                                        )}
                                        {getFieldDecorator("logs")(
                                            <Checkbox onChange={(e)=>{
                                                this.state.logs = e.target.checked
                                            }} checked={this.state.logs}>Logs</Checkbox>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item>
                                <Button
                                    className="user-btn"
                                    type="primary"
                                    size="large"
                                    // loading={this.state.loading}
                                    loading={loading}
                                    htmlType="submit"
                                    disabled={!formValid}
                                    block
                                >
                                    Save
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect()(Form.create()(editPackage)));
